import React from "react";
import PropTypes from "prop-types";

import Button from "@mui/material/Button";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { styled } from "@mui/material/styles";

const StyledButton = styled(Button)(({ theme }) => ({
  "&:focus-visible": {
    outline: theme.outline(),
    outlineOffset: "-2px"
  }
}));

function DeleteMaterialPositionModal({ positionId, removeMaterialPosition, hideModal, kind }) {
  return (
    <>
      <DialogTitle id={`${kind}-modal-title`}>Löschen bestätigen</DialogTitle>
      <DialogContent>
        <DialogContentText>Material an dieser Position wirklich löschen?</DialogContentText>
      </DialogContent>
      <DialogActions>
        <StyledButton
          variant="text"
          color="primary"
          onClick={() => {
            removeMaterialPosition(positionId);
            hideModal();
          }}
        >
          Löschen
        </StyledButton>
        <StyledButton variant="text" color="primary" onClick={() => hideModal()}>
          Abbrechen
        </StyledButton>
      </DialogActions>
    </>
  );
}

DeleteMaterialPositionModal.propTypes = {
  hideModal: PropTypes.func.isRequired,
  removeMaterialPosition: PropTypes.func.isRequired,
  positionId: PropTypes.string.isRequired,
  kind: PropTypes.string.isRequired
};

export default DeleteMaterialPositionModal;
